module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0044.jpg?v=822a1233";